class PdpNavigation extends HTMLElement {
  constructor() {
    super();

    // Navigation elements
    this.informationModuleLink = this.querySelector("#information_module");
    this.seriesModuleLink = this.querySelector("#series_module");
    this.pdpGalleryLink = this.querySelector("#pdp_gallery");
    this.pdpDesignLink = this.querySelector("#pdp_design");

    this.seriesDesignLink = this.querySelector("#series_design");
    this.seriesShopLink = this.querySelector("#series_shop");
    this.seriesInformationLink = this.querySelector("#series_information");
    this.seriesExploreLink = this.querySelector("#series_explore");

    // Document elements

    this.body = document.body;

    this.pdpInformationModule = document.querySelector("#pdpInformationModule");
    this.pdpSeriesModule = document.querySelector("#pdpSeriesModule");
    this.pdpGalleryModule = document.querySelector("#pdpGalleryModule");
    this.pdpDesignModule = document.querySelector("#pdpDesignModule");

    this.seriesDesignModule = document.querySelector("#series_design_module");
    this.seriesShopModule = document.querySelector("#series_shop_module");
    this.seriesInformationModule = document.querySelector(
      "#series_information_module"
    );
    this.seriesExploreModule = document.querySelector("#series_explore_module");

    this.init.bind(this);
    if (this.informationModuleLink) {
      this.informationModuleLink.addEventListener(
        "click",
        this.scrollToInfo.bind(this)
      );
    }

    if (this.seriesModuleLink && this.pdpSeriesModule) {
      this.seriesModuleLink.addEventListener(
        "click",
        this.scrollToSeries.bind(this)
      );
    }

    if (this.pdpGalleryLink && this.pdpGalleryModule) {
      this.pdpGalleryLink.addEventListener(
        "click",
        this.scrollToGallery.bind(this)
      );
    }

    if (this.pdpDesignLink && this.pdpDesignModule) {
      this.pdpDesignLink.addEventListener(
        "click",
        this.scrollToDesign.bind(this)
      );
    }

    // series
    if (this.seriesDesignLink && this.seriesDesignModule) {
      this.seriesDesignLink.addEventListener(
        "click",
        this.scrollToSeriesDesign.bind(this)
      );
    }
    if (this.seriesShopLink && this.seriesShopModule) {
      this.seriesShopLink.addEventListener(
        "click",
        this.scrollToSeriesShop.bind(this)
      );
    }
    if (this.seriesInformationLink && this.seriesInformationModule) {
      this.seriesInformationLink.addEventListener(
        "click",
        this.scrollToSeriesInformation.bind(this)
      );
    }
    if (this.seriesExploreLink && this.seriesExploreModule) {
      this.seriesExploreLink.addEventListener(
        "click",
        this.scrollToSeriesExplore.bind(this)
      );
    }
  }

  init() {}

  scrollToInfo() {
    const { pdpInformationModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    pdpInformationModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToSeries() {
    const { pdpSeriesModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    pdpSeriesModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToGallery() {
    const { pdpGalleryModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    pdpGalleryModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToDesign() {
    const { pdpDesignModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    pdpDesignModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToSeriesDesign() {
    const { seriesDesignModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    seriesDesignModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToSeriesShop() {
    const { seriesShopModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    seriesShopModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToSeriesInformation() {
    const { seriesInformationModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    seriesInformationModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }

  scrollToSeriesExplore() {
    const { seriesExploreModule } = this;
    this.body.classList.remove("scrolled_up", "scrolled_down");
    this.body.classList.add("scrolled_down");

    seriesExploreModule.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }
}

customElements.define("pdp-navigation", PdpNavigation);

//Back to top

const breakpoint = window.matchMedia("(max-width:989px)");
const isTabletOrMobile = breakpoint.matches === true;

if (!isTabletOrMobile) {
  const backToTop = document.querySelector("#back_to_top");
  const nav = document.querySelector(".pdp_navigation_wrapper");

  function scrollFunction() {
    if (
      document.body.scrollTop > 300 ||
      document.documentElement.scrollTop > 300
    ) {
      nav.classList.add("show");
    } else {
      nav.classList.remove("show");
    }
  }

  if (backToTop !== null) {
    window.onscroll = function () {
      scrollFunction();
    };

    backToTop.addEventListener("click", function () {
      document.querySelector("body").scrollIntoView({
        behavior: "smooth",
      });
      document.body.classList.remove("scrolled_down");
      document.body.classList.add("scrolled_up");
    });
  }
}

window.onscroll = function () {
  // hide when scrolling to end of page
  var viewportTop = window.pageYOffset;
  var viewportMiddle = viewportTop + window.innerHeight;
  const pdpNav = document.querySelector(".pdp_navigation_wrapper");
  const bell = document.querySelector("#bell");

  var elementTop =
    document.querySelector("#shopify-section-footer").getBoundingClientRect()
      .top - document.body.getBoundingClientRect().top;
  var elementBottom =
    elementTop +
    document.querySelector("#shopify-section-footer").getBoundingClientRect()
      .height;

  const isAtBottomOfPage =
    elementTop < viewportMiddle && elementBottom > viewportTop;

  if (pdpNav) {
    pdpNav.style.display = isAtBottomOfPage ? "none" : "unset";
  }

  if (
    window.matchMedia("(max-width: 767px)").matches &&
    document.body.getAttribute("data-template") === "collection"
  ) {
    var seriesShopModule = document.querySelector(".product-grid-container");

    if (window.scrollY >= seriesShopModule.offsetTop - window.innerHeight) {
      if (pdpNav) pdpNav.style.bottom = "-100%";
      if (bell) bell.style.bottom = "80px";
    } else {
      if (pdpNav) pdpNav.style.bottom = "0";
      if (bell) bell.style.bottom = "80px";
    }
  }
};

// check if wishlist element has loaded
// function waitForElement(querySelector, timeout) {
//   return new Promise((resolve, reject) => {
//     var timer = false;
//     if (document.querySelectorAll(querySelector).length) return resolve();
//     const observer = new MutationObserver(() => {
//       if (document.querySelectorAll(querySelector).length) {
//         observer.disconnect();
//         if (timer !== false) clearTimeout(timer);
//         return resolve();
//       }
//     });
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//     });
//     if (timeout)
//       timer = setTimeout(() => {
//         observer.disconnect();
//         reject();
//       }, timeout);
//   });
// }
// if (document.body.getAttribute("data-template") == "product") {
//   waitForElement(".swym-button", 3000).then(function () {
//     document.querySelector(".add2Cart_wishlist_wrapper").style.opacity = "1";
//   });

//   setTimeout(() => {
//     document.querySelector(".add2Cart_wishlist_wrapper").style.opacity = "1";
//   }, 4000);
// }

// set series background
if (document.getElementById("pdpSeriesModule")) {
  const desktopImg = document.querySelector(".series_bg.desktop_image img");
  if (desktopImg) {
    desktopImg.onload = function () {
      document.querySelector(
        ".series_bg.desktop_image .media"
      ).style.height = `calc(100vw * ${desktopImg.naturalHeight} / ${desktopImg.naturalWidth})`;
    };
  }

  const tabletImg = document.querySelector(".series_bg.tablet_image img");
  if (tabletImg) {
    tabletImg.onload = function () {
      document.querySelector(
        ".series_bg.tablet_image .media"
      ).style.height = `calc(100vw * ${tabletImg.naturalHeight} / ${tabletImg.naturalWidth})`;
    };
  }

  const mobileImg = document.querySelector(".series_bg.mobile_image img");
  if (mobileImg) {
    mobileImg.onload = function () {
      document.querySelector(
        ".series_bg.mobile_image .media"
      ).style.height = `calc(100vw * ${mobileImg.naturalHeight} / ${mobileImg.naturalWidth})`;
    };
  }
}
